module.exports = __webpack_public_path__ + "img/add-img-icon.75891762.png";